import { Typography } from '@/components/common';
import { ReactNode } from 'react';

interface Props {
	label: string;
	additionalInfoLabel?: string;
	className?: string;
	children: ReactNode;
}

export const FormItem: React.FC<Props> = ({
	label,
	className = '',
	children,
	additionalInfoLabel,
}) => {
	return (
		<div
			className={`flex flex-col md:flex-row items-start border-b py-5 gap-x-8 ${className}`}
		>
			<div className="md:w-[280px] mb-1 md:mb-0">
				<Typography type="semibold-14" className="text-left">
					{label}
					{additionalInfoLabel && (
						<span className="text-opacity-black font-semibold">
							{' '}
							{additionalInfoLabel}
						</span>
					)}
				</Typography>
			</div>
			<div className="flex-1 w-full">{children}</div>
		</div>
	);
};
